import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../utils/store';
import RFID from '../../../models/RFID';

export interface CreateRfidModalState {
    isOpen: boolean;
    rfid?: RFID;
}

const initialState: CreateRfidModalState = {
    isOpen: false,
};

export const slice = createSlice({
    name: 'createRfidModal',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setRfid: (state, action: PayloadAction<RFID>) => {
            state.rfid = action.payload;
        },
    },
});

export const { setOpen, setRfid } = slice.actions;
export const actions = slice.actions;

export const selectIsOpen = (state: RootState) => state.createRfidModal.isOpen;
export const selectRfid = (state: RootState) => state.createRfidModal.rfid;

export default slice.reducer;
